import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ReactNode, useMemo } from "react";

import { customizations } from "./customizations";
import { gameColorsDark, gameColorsLight } from "./gameColors";
import { colorSchemes, shadows, shape, typography } from "./themePrimitives";

interface AppThemeProps {
  children: ReactNode;
}

export const AppTheme = (props: AppThemeProps) => {
  const { children } = props;
  const theme = useMemo(
    () =>
      createTheme({
        cssVariables: {
          colorSchemeSelector: "data-mui-color-scheme",
          cssVarPrefix: "template",
        },
        // The in-house games read their felt, hairlines and outcome colors
        // off `palette.game`, so each scheme carries its own set and a board
        // follows the toggle without knowing which mode it is in.
        colorSchemes: {
          light: { palette: { ...colorSchemes.light.palette, game: gameColorsLight } },
          dark: { palette: { ...colorSchemes.dark.palette, game: gameColorsDark } },
        },
        defaultColorScheme: "dark",
        typography,
        shadows,
        shape,
        components: customizations,
      }),
    [],
  );

  return (
    <ThemeProvider defaultMode="dark" theme={theme} disableTransitionOnChange>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
